import {FilterType, OperatorItem} from '../../types/models'
import {ColumnMeta} from '../core/_models'

export const dataTableConfig: Record<FilterType, OperatorItem[]> = {
  string: [
    {label: 'В списке', value: 'inArray'},
    {label: 'Не в списке', value: 'notInArray'},
    {label: 'Равно', value: 'eq'},
    {label: 'Не равно', value: 'ne'},
    {label: 'Начинается с', value: 'startsWith'},
    {label: 'Заканчивается на', value: 'endsWith'},
  ],
  number: [
    {label: 'Равно', value: 'eq'},
    {label: 'Не равно', value: 'ne'},
    {label: 'Меньше', value: 'lt'},
    {label: 'Меньше или равно', value: 'lte'},
    {label: 'Больше', value: 'gt'},
    {label: 'Больше или равно', value: 'gte'},
    {label: 'Между', value: 'isBetween'},
  ],
  boolean: [{label: 'Равно', value: 'eq'}],
  'multi-select': [
    {label: 'Содержит любое из', value: 'inArray'},
    {label: 'Не содержит ни одного', value: 'notInArray'},
  ],
}

export const columnMeta: ColumnMeta[] = [
  {key: 'from_', label: 'Клиент (телефон)', type: 'string'},
  {key: 'to_', label: 'Сотрудник', type: 'string'},
  {key: 'did_number', label: 'Линия', type: 'string'},
  {key: 'status', label: 'Статус', type: 'multi-select'},
  {key: 'talk_duration', label: 'Длительность (сек)', type: 'number'},
  {key: 'dial_duration', label: 'Ожидание (сек)', type: 'number'},
  {key: 'record_url', label: 'Запись разговора', type: 'boolean'},
]
